<template>
    <div class="video-warpper">
    <header class="header">
      <div class="logo">
        <img src="../assets/image/logo-white.png" @click='toOfficial' alt>
        <span class="line"></span>
        <h3 class="title">K12情景式智慧教学产品</h3>
      </div>
      <div class="info-wrapper">
        <div class="info">
          <div class="exchange" @click="exchange">
            <img src="../assets/image/activate.png" class="icon" alt="" />
            <span>兑换课程</span>
          </div>
          <span>Hi,{{nickname}}{{isTeacher? '老师' : '同学'}}</span>
          <img :src="getAvatar(avatar)">          
        </div>
        <!-- <div class="download">
          <i class="icon-phone"></i>
          <span>学生端APP</span>
        </div> -->
        <div class="exit" @click="logout">
          <i class="icon-exit"></i>
          <span>退出登录</span>
        </div>
      </div>
    </header>
    <main class="main">
      <router-view></router-view>
      
          
      <!-- </div> -->
    </main>
  </div>
</template>

<script>
import { Row, Col } from "element-ui";
import axios from "axios";
import defaultAvatar from '../assets/image/avatar.png'
export default {
data() {
    return {
      nickname: "",
      isTeacher: false,
      avatar: "",
      levelIndex: 0,
      courseType: ["全部"],
      showIndex: 0,
      courseList: []
    };
  },
  components: {
    ElRow: Row,
    ElCol: Col
  },
  created() {
    let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    this.nickname = userInfo.nickname;
    this.avatar = userInfo.avatar;
    this.isTeacher = sessionStorage.getItem('isTeacher') == 'true'
    console.log(sessionStorage.getItem('isTeacher')== 'false', typeof sessionStorage.getItem('isTeacher'))
  },
  methods: {
    exchange() {
      this.$route.path !== '/video/activate' && this.$router.push('/video/activate');
    },
      getAvatar(avatar){
        return avatar? avatar : defaultAvatar
    },
    logout() {
      var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
      if (keys) {
          for (var i = keys.length; i--;) {
              document.cookie = keys[i] + '=0;path=/;expires=' + new Date(0).toUTCString();//清除当前域名下的,例如：m.kevis.com
              document.cookie = keys[i] + '=0;path=/;domain=' + document.domain + ';expires=' + new Date(0).toUTCString();//清除当前域名下的，例如 .m.kevis.com
              document.cookie = keys[i] + '=0;path=/;domain=kevis.com;expires=' + new Date(0).toUTCString();//清除一级域名下的或指定的，例如 .kevis.com
          }
      }
      console.log(document.cookie)
        // sessionStorage.clear()
      this.$router.push('/login')
    },
    toOfficial(){
      location.href = 'https://www.kehigh.com/'
    }
  }
}
</script>

<style lang='scss' scoped>
.video-warpper {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  .header {
    flex-shrink: 0;
    height: 82px;
    background-color: #38b5ef;
    padding: 0 4.3634%;
    font-size: 16px;
    color: #363468;
    box-shadow: 0px 6px 10px 0px 	rgba(117, 92, 195, 0.1);
    display: flex;
    align-items: center;
    justify-content: space-between;
    .logo{
      display: flex;
      align-items: center;
      img{
        height: 35px;
        cursor: pointer;
      }
      .line{
        display: inline-block;
        margin: 0 22px;
        border-right: 1px solid #fff;
        height: 30px;
        border-radius: 1px;
      }
      .title{
        display: inline-block;
        font-size: 20px;
        color: #fff;
      }
    }
    .info-wrapper {
      display: flex;
      .info {
        display: flex;
        align-items: center;
        font-size: 14px;
        color: #fff;
        // margin-right: 86px;
        .exchange {
          display: flex;
          align-items: center;
          justify-content: space-around;
          height: 32px;
          width: 90px;
          line-height: 32px;
          font-size: 12px;
          color: #000;
          padding-right: 10px;
          background-color: #fff;
          border-radius: 16px;
          margin-right: 20px;
          cursor: pointer;
          .icon {
            margin-left: 0;
            height: 25px;
            width: 25px;
          }
        }
        img {
          // margin-right: 8px;
          margin-left: 14px;
          border-radius: 50%;
          width: 40px;
          height: 40px;
        }
      }
      .download {
        display: flex;
        align-items: center;
        margin-right: 67px;
        position: relative;
        .icon-phone {
          margin-right: 10px;
          width: 21px;
          height: 27px;
          background: url(../assets/image/download.png) no-repeat center center;
          background-size: cover;
        }
        &:hover::after {
          content: "";
          position: absolute;
          top: 35px;
          left: -35px;
          display: block;
          width: 204px;
          height: 248px;
          background: url(../assets/image/appQR.png) no-repeat center center;
          background-size: cover;
          z-index: 100;
        }
      }
      .exit {
        margin-left: 20px;
        display: flex;
        align-items: center;
        cursor: pointer;
        color: #fff;
        .icon-exit {
          margin-right: 5px;
          width: 14px;
          height: 14px;
          background: url(../assets/image/exit.png) no-repeat center center;
          background-size: cover;
        }
      }
    }
  }
  .main {
    flex-grow: 1;
    background-color: #eff4f8;
    // .video-container {
    //   width: 80%;
    //   margin: 0 auto;
    //   min-height: 500px;
    //   background-color: #fff;
    //   padding: 24px 16px 50px;
    //   border-radius: 10px;
    //   box-shadow: 0 6px 10px 0 rgba(54, 52, 104, 0.15);
    //   margin-top: 50px;
    // }
  }
}

@media screen and (max-width: 751px){
  .video-warpper {
 
  .header {
    padding: 0 10px;
    font-size: 14px;
    .logo{
      img{
        height: 30px;
      }
    }
    .info-wrapper {
      .info {
        margin-right: 8px;
        img {
          margin-right: 3px;
          border-radius: 50%;
          width: 30px;
          height: 30px;
        }
      }
      .download {
        display: none;
      }
      .exit {
        .icon-exit {
          margin-right: 5px;
          width: 20px;
          height: 20px;
        }
      }
    }
  }
  .main {
    .video-container {
      padding: 24px 16px 0px;
      border-radius: 10px;
      box-shadow: 0 6px 10px 0 rgba(54, 52, 104, 0.15);
      margin-top: 20px;
    }
  }
}
}
</style>
